/**
 * Set up routing for all Study views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import study views
import StudyDashboardActiveSiteBillingReport from './views/StudyDashboardActiveSiteBillingReport.js.jsx';
// import StudyDashboardDownloadCompletionReport from './views/StudyDashboardDownloadCompletionReport.js.jsx';
import StudyDashboardLayout from './components/StudyDashboardLayout.js.jsx';


class StudiesDashboardRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    // let singleStudyDownloadCompletionPath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/download-completion-report'), 0);
    let singleStudyActiveBillingPath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/active-site-billing'), 0);

    return (
      <StudyDashboardLayout>
        <Switch>
          {/* NEW - both of these should still exist, but should redirect immediately back to the hub */}
          <YTRoute
            exact
            login={true}
            path="/studies-dashboard"
            render={() => {
              window.location.href = `${window.hubUrl}`;
              return null;
            }} 
          />
          <YTRoute
            exact
            login={true}
            path="/studies-dashboard/:studyId"
            render={() => {
              window.location.href = `${window.hubUrl}`;
              return null;
            }} 
          />

          <YTRoute
            breadcrumbs={[{display: 'Programs dashboard', path: '/studies-dashboard'}, {display: 'Program details', path: singleStudyActiveBillingPath}, {display: 'Active site billing report', path: null }]}
            component={StudyDashboardActiveSiteBillingReport}
            exact
            login={true}
            role="admin"
            path="/studies-dashboard/:studyId/active-site-billing"
          />
          
        </Switch>
      </StudyDashboardLayout>
    )
  }
}

export default StudiesDashboardRouter;



// WEBPACK FOOTER //
// modules/study/StudiesDashboardRouter.js.jsx